import { connect } from "react-redux";
import { getServerTimeDifference } from "../selectors";
import Countdown from "../components/countdown";

function select(state, props) {
  return {
    serverTimeDifference: getServerTimeDifference(state, props)
  };
}

export default connect(select)(Countdown);
